<template>
    <el-dialog
        :before-close="cancel"
        :close-on-press-escape="false"
        :visible.sync="dialogVisible"
        append-to-body
        center
        top="3%"
        width="60%">
        <div class="flex flex-direction padding-lr-xs" style="height: 70vh;overflow: auto">
            <div class="text-xxl line-height text-bold text-black text-center">{{detail.status_name}}</div>
            <div class="label-classify-title">活动内容</div>
            <div class="margin-top-sm detail" v-html="detail.content"></div>
            <div class="margin-top-sm" v-if="detail.status >= 2">
                <div class="label-classify-title flex align-center">
                    <div>内容补充</div>
                </div>
                <div class="text-df line-height text-indent margin-tb-sm">{{ detail.remark }}</div>
            </div>
            <div class="margin-top-sm" v-if="detail.status >= 3">
                <div class="label-classify-title">活动简报</div>
                <div class="margin-top-sm detail" v-html="detail.brief_report"></div>
            </div>
        </div>
    </el-dialog>
</template>

<script>


import {getThemeActivitiesDetail} from "@/api";

export default {
    name: "ThemeActivitiesDetailDialog",
    components: {},
    data() {
        return {
            detail:''
        }
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        type: {//1党员大会 2 委员会
            type: Number,
            default: 1
        },
        aid: {
            type: Number,
            default: 0
        },
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
    },
    created() {
        if (this.aid) this.init()
    },
    methods: {
        async init() {
            let _data = await getThemeActivitiesDetail(this.aid)
            this.detail = _data.data
        },
        cancel() {
            this.$emit('watchState', false)
        },
    },
    filters: {},
    watch: {
        aid() {
            if (this.aid) this.init()
        }
    }
}
</script>

<style lang="scss" scoped>
.label-classify-title {
    font-size: 24px;
    color: #333333;
    position: relative;
    border-bottom: 3px solid #a0121222;
    height: 50px;
    line-height: 50px;
    &::before{
        position: absolute;
        width: 98px;
        height: 4px;
        background-color: #a01212;
        content: '';
        bottom: -3px;
        left: 0;
    }
}
</style>